import React, { useEffect, useState } from 'react';
import { ArrowUpCircleIcon } from 'lucide-react';
const FloatingCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show button when scrolled 30% down the page
      const scrollThreshold = document.documentElement.scrollHeight * 0.3;
      if (window.scrollY > scrollThreshold) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-6 right-6 z-40 flex flex-col items-end space-y-4" data-id="element-111">
      <a href="https://pay.hotmart.com/J101918467L?off=59zwd0bh&checkoutMode=10" className="flex items-center bg-[#E25822] hover:bg-[#C64718] text-white font-bold py-3 px-5 rounded-full shadow-lg transition-all transform hover:scale-105 animate-pulse" data-id="element-112">
        ¡Obtener Combo Ahora!
      </a>
    </div>;
};
export default FloatingCTA;